import { useState } from 'react';
import { HelpCircle } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { Modal } from '../../../Shared/Modal/Modal';
import { Project } from '../../../Shared/types';
import { Button } from '../../../Shared/UI/Button';
import { Icon } from '../../../Shared/UI/Icon';

export const DefaultProjectLabel = ({ project }: { project: Project; }) => {
  const { t } = useTranslation();

  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <span className="text-sm font-medium text-slate-500">
        {t('backend:default_project')}
        {' '}
        <Button onClick={() => setShowModal(true)} variant="inline" size="sm" title={t('backend:info')}>
          <Icon>
            <HelpCircle />
          </Icon>
        </Button>
      </span>

      <Modal isOpen={showModal} onClose={() => setShowModal(false)} size="sm">
        <h3 className="py-1 mb-2">
          {t(`backend:project_types.${project.type}`)}
        </h3>
        <p>
          {t(`backend:default_project_type_descriptions.${project.type}`)}
        </p>
      </Modal>
    </>
  );
};
